// src/store/slices/reportesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReporteService from 'services/ReporteService';

export const fetchDashboard = createAsyncThunk(
    'reportes/fetchDashboard',
    async (params, { rejectWithValue }) => {
        try {
            return await ReporteService.getDashboard(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar el dashboard');
        }
    }
);

export const fetchMapa = createAsyncThunk(
    'reportes/fetchMapa',
    async (params, { rejectWithValue }) => {
        try {
            return await ReporteService.getMapa(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar el mapa');
        }
    }
);

const reportesSlice = createSlice({
    name: 'reportes',
    initialState: {
        dashboard: null,
        mapa: { puntos: [], geocercas: [], meta: null },
        loading: false,
        loadingMapa: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboard.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchDashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboard = action.payload.data;
            })
            .addCase(fetchDashboard.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

            .addCase(fetchMapa.pending, (state) => { state.loadingMapa = true; })
            .addCase(fetchMapa.fulfilled, (state, action) => {
                state.loadingMapa = false;
                state.mapa = {
                    puntos: action.payload.data,
                    geocercas: action.payload.geocercas,
                    meta: action.payload.meta,
                };
            })
            .addCase(fetchMapa.rejected, (state, action) => { state.loadingMapa = false; state.error = action.payload; });
    },
});

export default reportesSlice.reducer;
